__webpack_require__.p = "/visual-maths/";